// TODO: remove this file after legacy libraries rewriting (@yola/yousersjs)
// eslint-disable-next-line
import axios from 'axios';

export default axios;
